import Span from 'src/components/atomic/atom/Span'
import { COLOR } from 'src/constants/colors'
import React from 'react'
import styled, { css } from 'styled-components'

interface NumberMarkerProps {
  active?: boolean
  markerText: string
  lat?: number
  lng?: number
  onClickFn?: () => void
}
const NumberMarker = (props: NumberMarkerProps) => {
  const { active, markerText } = props

  return (
    <NumberMarkerWrap onClick={props.onClickFn} active={`${active}`}>
      <Span display={'block'} option={'tiny_bold'} color={COLOR.white} $line_height={'24px'}>
        {markerText}
      </Span>
    </NumberMarkerWrap>
  )
}
export default NumberMarker

const NumberMarkerWrap = styled.div<{ active?: string }>`
  position: ${(props) => (props.active === 'undefined' ? 'unset' : 'absolute')};
  z-index: ${(props) => (props.active === 'true' ? 99 : 'unset')};
  display: flex;
  height: 24px;

  min-width: 24px;
  padding: 0 4px;
  border-radius: 50px;
  background: ${COLOR.red80};
  ${(props) =>
    props.active === 'true' &&
    css`
      &:after {
        content: '';
        position: absolute;
        top: 21px;
        width: 0;
        height: 0;
        border-left: 6.5px solid transparent;
        border-right: 6.5px solid transparent;
        border-top: calc(6.5px * 1.732) solid ${COLOR.red80};
        right: 5.4px;
      }
    `}
`
